import * as React from 'react';
import styled from 'styled-components';

export const CONTAINER_PADDING = 32;

const Container = styled.div<{ maxWidth?: string }>`
    display: flex;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : `1600px`)};
    width: 100%;
    margin: auto;
    gap: ${CONTAINER_PADDING}px;
    padding: ${CONTAINER_PADDING}px;
    min-height: calc(var(--body-height) - ${CONTAINER_PADDING * 2}px);
`;

export interface JRCAppContainerProps {
    children: React.ReactNode;
    maxWidth?: string;
}

const JRCAppContainer = ({ maxWidth, children }: JRCAppContainerProps) => (
    <Container maxWidth={maxWidth}>{children}</Container>
);

export { JRCAppContainer };
